export enum GatewayAlarmStatusEnum {
  ONLINE = 0,
  OFFLINE = 1
}

export class GatewayAlarmStatus {
  gatewayId!: number;
  status!: GatewayAlarmStatusEnum;
  ts!: number;

  constructor(gatewayId: number, status: GatewayAlarmStatusEnum, ts: number = new Date().getTime()) {
    this.gatewayId = gatewayId;
    this.status = status;
    this.ts = ts;
  }

}
